module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-4-photo-5-5365bc4e0281e1afd8b4429be4e01e39.webp";